import React from 'react'

const BlankLayout: React.FC = ({ children }) => {
  return <React.Fragment>{children}</React.Fragment>
}

export default BlankLayout
